import React from 'react';
import './Footer.css';
import { useLanguage } from '../context/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="footer-brand footer-brand-centered">
          <div className="footer-logo">
            <img src="/LOGO.png" alt="Volcano Vodka" className="footer-logo-img" />
          </div>
          <p className="footer-tagline">
            {t.footer.tagline}
          </p>
          <div className="temperature">
            <span className="temp-value">{t.footer.madeIn}</span>
            <span className="temp-label">— {t.footer.obsidianFiltered}</span>
          </div>
          <div className="social-links">
            <a href="#instagram" className="social-link" aria-label="Instagram">
              <svg viewBox="0 0 24 24" fill="none" width="20" height="20">
                <rect x="2" y="2" width="20" height="20" rx="5" stroke="currentColor" strokeWidth="1.5"/>
                <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="1.5"/>
                <circle cx="18" cy="6" r="1" fill="currentColor"/>
              </svg>
            </a>
            <a href="#twitter" className="social-link" aria-label="Twitter">
              <svg viewBox="0 0 24 24" fill="none" width="20" height="20">
                <path d="M4 4L10.5 12.5L4 20H6L11.5 14L16 20H20L13 11L19 4H17L12 9.5L8 4H4Z" stroke="currentColor" strokeWidth="1.5"/>
              </svg>
            </a>
            <a href="#tiktok" className="social-link" aria-label="TikTok">
              <svg viewBox="0 0 24 24" fill="none" width="20" height="20">
                <path d="M9 12C9 14.2091 10.7909 16 13 16V20C8.58172 20 5 16.4183 5 12C5 7.58172 8.58172 4 13 4V8C10.7909 8 9 9.79086 9 12Z" stroke="currentColor" strokeWidth="1.5"/>
                <path d="M13 4V12" stroke="currentColor" strokeWidth="1.5"/>
                <path d="M13 4C15.2091 4 17 5.79086 17 8V4" stroke="currentColor" strokeWidth="1.5"/>
                <path d="M17 8C19.2091 8 21 6.20914 21 4" stroke="currentColor" strokeWidth="1.5"/>
              </svg>
            </a>
          </div>
        </div>
      </div>

      <div className="footer-middle">
        <div className="philosophy-text">
          {t.footer.philosophy.map((text, index) => (
            <span key={index}>{text}</span>
          ))}
        </div>
      </div>

      <div className="footer-bottom">
        <div className="copyright">
          © {new Date().getFullYear()} {t.footer.copyright}
        </div>
        <div className="age-warning">
          <svg viewBox="0 0 24 24" fill="none" width="16" height="16">
            <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.5"/>
            <text x="12" y="16" textAnchor="middle" fill="currentColor" fontSize="9" fontWeight="bold">18</text>
          </svg>
          <span>{t.footer.ageWarning}</span>
        </div>
        <div className="drink-responsible">
          {t.footer.drinkResponsibly}
        </div>
      </div>

      <div className="footer-decoration">
        <div className="deco-line"></div>
        <div className="deco-volcano">
          <svg viewBox="0 0 100 50" width="100" height="50">
            <path d="M50 5 L70 40 L80 40 L50 48 L20 40 L30 40 Z" fill="none" stroke="rgba(192,192,192,0.3)" strokeWidth="1"/>
            <circle cx="50" cy="10" r="3" fill="rgba(192,192,192,0.5)"/>
          </svg>
        </div>
        <div className="deco-line"></div>
      </div>
    </footer>
  );
};

export default Footer;
